import { makeStyles, tokens } from "@fluentui/react-components"
export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    // by default attempt to fill parent. Normally would have this passed in via classname but
    // due to Outlet not passing through props, we default to this and require pages that do not
    // want this behavior to override themselves.
    height: '100%',
  },
  content: {
    height: '100%',
    maxHeight: '100%',
    overflowY: 'scroll',
    paddingLeft: tokens.spacingHorizontalXL
  },
  header: {
    paddingLeft: 0,
  },
  form: {
    maxWidth: "700px",
  },
  footer: {
    height: "100px", //TODO(nibeauli): check with Jitish about height
    boxSizing: "border-box",
    backgroundColor: tokens.colorNeutralBackground2,
    //borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    margin: 0,
    paddingLeft: tokens.spacingHorizontalXXXL, //TODO(nibeauli): design calls for 44px padding but that is 8px larger than largest spacing token
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    gap: tokens.spacingHorizontalS,
    display: 'flex',
    alignItems: 'center',
    zIndex: 2, // push this above so boxshadow works
    //TODO(nibeauli): factor this out as a custom token
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.12), 0 -2px 4px rgba(0, 0, 0, 0.14)', //tokens.shadow 4 only does 2px downward not upward box shadow.
  }
});

